import React, { useState } from 'react';
import Card from './Card';
import '../css/equipment-card.sass';
import LinkButton from './LinkButton';
import SectionMessage, { SectionMessageType } from './SectionMessage';
import CampfireButton from './CampfireButton';

export interface EquipmentCardPropsType {
  imageUrl: string;
  fallbackImageUrl?: string;
  children: React.ReactNode;
  name: string;
  equipmentType: 'RECEIVER' | 'INTERNET' | 'REPLACEMENT';
  detailsPageLink?: string;
  detailsLinkLabel?: string;
  poweredLabel?: string;
  isPowered?: boolean;
  message?: SectionMessageType[];
  theme?: 'day' | 'night';
  isManageable?: boolean;
  manageEquipmentBtnLabel?: string;
  onManageEquipment?: Function;
  togglePower?: React.ReactNode;
}

export default function EquipmentsCard(props: EquipmentCardPropsType) {
  const {
    isPowered = false,
    theme = 'day',
    isManageable = false,
    manageEquipmentBtnLabel = ' Manage Receiver Status'
  } = props;

  const [isImgFound, setIsImgFound] = useState(true);

  return (
    <div className="equipment-card">
      <Card theme={theme}>
        <div className="device">
          <div className="receiversName">{props.name}</div>
          {!props.togglePower && (
            <div className="receiver-status">
              <div className="statusLabel">
                {props.poweredLabel || (isPowered ? 'Powered' : 'No Power')}
              </div>
              <span
                className={`${props.equipmentType.toLowerCase()}-${
                  isPowered ? 'on' : 'off'
                } icon`}
              />
            </div>
          )}
        </div>
        <div className="receiversImg">
          {isImgFound ? (
            <img
              src={props.imageUrl}
              alt="receiversImg"
              onError={() => {
                setIsImgFound(false);
              }}
            />
          ) : (
            <img
              src={props.fallbackImageUrl || props.imageUrl}
              alt="receiversImg"
            />
          )}
        </div>
        <div className="content">{props.children}</div>
        {props.message && (
          <div className="messageSection">
            <SectionMessage messages={props.message} />
          </div>
        )}

        {props.detailsLinkLabel && props.detailsPageLink && (
          <div className={!props.message ? 'linkButton' : 'sectionMsg'}>
            <LinkButton
              name="detailsLink"
              id="detailsLink"
              forward
              onClick={() =>
                props.detailsPageLink &&
                window.location.assign(props.detailsPageLink)
              }
            >
              {props.detailsLinkLabel}
            </LinkButton>
          </div>
        )}
        {isManageable && !props.detailsPageLink && props.onManageEquipment && (
          <div
            className={`${
              !isPowered ? 'receiverPoweredOff' : 'manageReceiverStatusBtn'
            }`}
          >
            <CampfireButton
              name={manageEquipmentBtnLabel}
              id="manageReceiverStatusBtn"
              label={manageEquipmentBtnLabel}
              onClick={props.onManageEquipment}
              ghost
            />
          </div>
        )}
        {props.togglePower}
      </Card>
    </div>
  );
}
